import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";

const RangeSlider = ({
    min = 0,
    max = 100,
    step = 1,
    initialMin = 20,
    initialMax = 80,
    onChange = () => { },
}) => {
    const trackRef = useRef(null);

    const [minVal, setMinVal] = useState(initialMin);
    const [maxVal, setMaxVal] = useState(initialMax);
    const [minInput, setMinInput] = useState(initialMin);
    const [maxInput, setMaxInput] = useState(initialMax);
    const [activeThumb, setActiveThumb] = useState(null);

    const getPercent = (v) => ((v - min) / (max - min)) * 100;
    const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

    const isValidNumber = (value) => /^\d*$/.test(value);

    useEffect(() => {
        setMinInput(Math.round(minVal));
        setMaxInput(Math.round(maxVal));
    }, [minVal, maxVal]);

    useEffect(() => {
        if (!activeThumb) return;

        const onMove = (e) => {
            const rect = trackRef.current.getBoundingClientRect();
            const percent = clamp((e.clientX - rect.left) / rect.width, 0, 1);
            const value = Math.round((percent * (max - min) + min) / step) * step;

            if (activeThumb === "min" && value < maxVal) setMinVal(value);
            if (activeThumb === "max" && value > minVal) setMaxVal(value);
        };

        const onUp = () => {
            onChange(minVal, maxVal);
            setActiveThumb(null);
        };

        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp);

        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseup", onUp);
        };
    }, [activeThumb, minVal, maxVal]);


    const commitMin = () => {
        if (minInput === "") {
            setMinInput(minVal);
            return;
        }
        const value = clamp(Math.round(Number(minInput)), min, maxVal - step);
        setMinVal(value);
        setMinInput(value);
        onChange(value, maxVal);
    };

    const commitMax = () => {
        if (maxInput === "") {
            setMaxInput(maxVal);
            return;
        }
        const value = clamp(Math.round(Number(maxInput)), minVal + step, max);
        setMaxVal(value);
        setMaxInput(value);
        onChange(minVal, value);
    };

    return (
        <div className="range-wrapper">
            <div className="range-track" ref={trackRef}>
                <div
                    className="range-filled"
                    style={{
                        left: `${getPercent(minVal)}%`,
                        width: `${getPercent(maxVal) - getPercent(minVal)}%`,
                    }}
                />
                <div
                    className="thumb left"
                    style={{ left: `${getPercent(minVal)}%` }}
                    onMouseDown={() => setActiveThumb("min")}
                />
                <div
                    className="thumb right"
                    style={{ left: `${getPercent(maxVal)}%` }}
                    onMouseDown={() => setActiveThumb("max")}
                />
            </div>

            <div className="priceGroup">
                <div className="cart-select-wrapper">
                    <input
                        name="minPrice"
                        type="text"
                        className="cart-grid-select cart-select-arrow"
                        id="min-price"
                        value={minInput}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (isValidNumber(value)) {
                                setMinInput(value);
                            }
                        }}
                        onBlur={commitMin}
                        onKeyDown={(e) => e.key === "Enter" && commitMin()}
                    />
                    <label htmlFor="min-price"> Min </label>
                </div>

                <span>to</span>

                <div className="cart-select-wrapper ">
                    <input
                        name="maxPrice"
                        type="text"
                        className="cart-grid-select cart-select-arrow"
                        id="max-price"
                        value={maxInput}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (isValidNumber(value)) {
                                setMaxInput(value);
                            }
                        }}
                        onBlur={commitMax}
                        onKeyDown={(e) => e.key === "Enter" && commitMax()}
                    />
                    <label htmlFor="max-price"> Max </label>
                </div>
            </div>
        </div>
    );
};

RangeSlider.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    initialMin: PropTypes.number,
    initialMax: PropTypes.number,
    onChange: PropTypes.func,
};
export default RangeSlider;
